import React from "react";

import { Box, Breadcrum } from "atoms";
import { useLocation } from "react-router";
import ActivityLog from "./ActivityLog";
import Profile from "./Profile";
import Roles from "./Roles";
// import UserActivity from "./UserActivity";
import Users from "./Users";
import Archive from "./Archive";

export const Setting = () => {
  const location = useLocation();
  return (
    <Box>
      <Breadcrum
        firstText="settings"
        secondText={location.pathname
          .replace("/setting/", "")
          .replace("-", " ")}
      />

      <Box>
        {location.pathname === "/setting/activity-log" && <ActivityLog />}
        {/* {location.pathname === "/setting/activity-log/user-activity" && <UserActivity />} */}
        {location.pathname === "/setting/roles" && <Roles />}
        {location.pathname === "/setting/archive" && <Archive />}
        {location.pathname === "/setting/users" && <Users />}
        {location.pathname === "/setting/profile" && <Profile />}
      </Box>
    </Box>
  );
};
